import { Provider } from "@redotech/redo-model/order";
import * as z from "zod/v4";

export const getProvidersForTeam = {
  name: "getProvidersForTeam" as const,
  input: z.object({ teamId: z.string() }),
  output: z.array(z.enum(Provider)),
};
